import * as Cesium from 'cesium';
import { generateId } from '../../utils/idGeneration';
import { calculatePolygonAreaM2 } from '../../utils/geometryUtils';
export { formatAreaFromSqMeters as formatArea, convertAreaToUnit } from '../../utils/units';
export const generateVertexId = () => generateId('vertex');
export const generatePolygonId = () => generateId('polygon');
// Use the same spherical-excess area calculation as the polygon-drawing flow so
// the area shown mid-draw matches the area of the finished/saved artifact.
export const calculatePolygonArea = (positions) => {
    if (positions.length < 3)
        return 0;
    const coords = positions.map(p => {
        const c = Cesium.Cartographic.fromCartesian(p);
        return {
            lat: Cesium.Math.toDegrees(c.latitude),
            lng: Cesium.Math.toDegrees(c.longitude)
        };
    });
    return calculatePolygonAreaM2(coords);
};
export const calculatePerimeter = (positions) => {
    if (positions.length < 2)
        return 0;
    let perimeter = 0;
    for (let i = 0; i < positions.length; i++) {
        const j = (i + 1) % positions.length;
        perimeter += Cesium.Cartesian3.distance(positions[i], positions[j]);
    }
    return perimeter;
};
export const calculateEdges = (positions) => {
    if (positions.length < 3)
        return [];
    const edges = [];
    for (let i = 0; i < positions.length; i++) {
        const j = (i + 1) % positions.length;
        edges.push({
            id: `edge-${i}-${j}`,
            startVertexIndex: i,
            endVertexIndex: j,
            distanceMeters: Cesium.Cartesian3.distance(positions[i], positions[j]),
        });
    }
    return edges;
};
